"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextStyled = exports.modifiers = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_components_modifiers_1 = require("styled-components-modifiers");
exports.modifiers = {
  xxLarge: function xxLarge() {
    return {
      styles: "\n      font-size: 1.5rem;\n      line-height: 1.75rem;\n    "
    };
  },
  xLarge: function xLarge() {
    return {
      styles: "\n      font-size: 1rem;\n      line-height: 1.75rem;\n    "
    };
  },
  small: function small() {
    return {
      styles: "\n      font-size: 0.7rem;\n      line-height: normal;\n    "
    };
  },
  tiny: function tiny() {
    return {
      styles: "\n      font-size: 0.65rem;\n      line-height: normal;\n    "
    };
  },
  inverted: function inverted(_ref) {
    var theme = _ref.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.gray_3, ";\n    ")
    };
  },
  brandFont: function brandFont(_ref2) {
    var theme = _ref2.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      * {\n        font-family: ").concat(theme.farmProject.font_family, ";\n      }\n    ")
    };
  },
  brandLarge: function brandLarge(_ref3) {
    var theme = _ref3.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      font-size: 2.3125rem;\n      color: ").concat(theme.farmProject.brand_primary, ";\n      line-height: 2.75rem;\n    ")
    };
  },
  brand: function brand(_ref4) {
    var theme = _ref4.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      font-size: 1.875rem;\n      color: ").concat(theme.farmProject.brand_primary, ";\n      line-height: 2.75rem;\n    ")
    };
  },
  brandSmall: function brandSmall(_ref5) {
    var theme = _ref5.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      font-size: 1.5625rem;\n      color: ").concat(theme.farmProject.brand_primary, ";\n      line-height: 1.875rem;\n    ")
    };
  },
  brandSmallWhite: function brandSmallWhite(_ref6) {
    var theme = _ref6.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      font-size: 1.5625rem;\n      color: ").concat(theme.farmProject.gray_3, ";\n      line-height: 1.875rem;\n    ")
    };
  },
  brandTiny: function brandTiny(_ref7) {
    var theme = _ref7.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      font-size: 0.65rem;\n      color: ").concat(theme.farmProject.brand_primary, ";\n      line-height: 1;\n    ")
    };
  },
  brandLight: function brandLight(_ref8) {
    var theme = _ref8.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      * {\n        font-family: ").concat(theme.farmProject.font_family, ";\n      }\n      font-weight: 300;\n      * {\n        font-weight: 300;\n      }\n    ")
    };
  },
  assignature: function assignature(_ref9) {
    var theme = _ref9.theme;
    return {
      styles: "\n      font-family: ".concat(theme.farmProject.font_family, ";\n      font-size: 1rem;\n      letter-spacing: 0;\n      color: ").concat(theme.farmProject.brand_primary, ";\n      line-height: 1.125rem;\n    ")
    };
  },
  error: function error(_ref10) {
    var theme = _ref10.theme;
    return {
      styles: "\n      letter-spacing: 0;\n      font-family: ".concat(theme.farmProject.font_family, ";\n      color: ").concat(theme.farmProject.error, ";\n      * {\n        color: ").concat(theme.farmProject.error, ";\n      }\n    ")
    };
  },
  errorColor: function errorColor(_ref11) {
    var theme = _ref11.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.error, ";\n    ")
    };
  },
  lightGrayColor: function lightGrayColor(_ref12) {
    var theme = _ref12.theme;
    return {
      styles: "\n    color: ".concat(theme.farmProject.light_gray, ";\n    ")
    };
  },
  midGrayColor: function midGrayColor(_ref13) {
    var theme = _ref13.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.mid_gray, ";\n    ")
    };
  },
  darkGrayColor: function darkGrayColor(_ref14) {
    var theme = _ref14.theme;
    return {
      styles: "\n    color: ".concat(theme.farmProject.dark_gray, ";\n    ")
    };
  },
  darkGreenColor: function darkGreenColor(_ref15) {
    var theme = _ref15.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.dark_green, ";\n    ")
    };
  },
  brandColor: function brandColor(_ref16) {
    var theme = _ref16.theme;
    return {
      styles: "\n      color: ".concat(theme.farmProject.brand_primary, ";\n    ")
    };
  },
  medium: function medium() {
    return {
      styles: "\n      font-size: 1.125rem;\n      line-height: 1;\n      font-weight: 300;\n    "
    };
  },
  bold: function bold() {
    return {
      styles: "\n      font-weight: bold;\n      * {\n        font-weight: bold;\n      }\n    "
    };
  },
  semibold: function semibold() {
    return {
      styles: "\n      font-weight: 500;\n      * {\n        font-weight: 500;\n      }\n    "
    };
  },
  light: function light() {
    return {
      styles: "\n      font-weight: 300;\n      * {\n        font-weight: 300;\n      }\n    "
    };
  },
  italic: function italic() {
    return {
      styles: "\n      font-style: italic;\n      "
    };
  },
  lineHeightSmall: function lineHeightSmall() {
    return {
      styles: "\n      line-height: 1.5rem;\n      * {\n        line-height: 1.5rem;\n      }\n    "
    };
  },
  noLineHeight: function noLineHeight() {
    return {
      styles: "\n      line-height: normal;\n    "
    };
  },
  noLetterSpace: function noLetterSpace() {
    return {
      styles: "\n        letter-spacing: 0;\n      "
    };
  },
  normalLetterSpace: function normalLetterSpace() {
    return {
      styles: "\n        letter-spacing: normal;\n      "
    };
  },
  preWrap: function preWrap() {
    return {
      styles: "\n      white-space: pre-wrap;\n    "
    };
  },
  lineThrough: function lineThrough() {
    return {
      styles: "\n      text-decoration: line-through;\n    "
    };
  },
  left: function left() {
    return {
      styles: "text-align: left;"
    };
  },
  center: function center() {
    return {
      styles: "text-align: center;"
    };
  },
  right: function right() {
    return {
      styles: "text-align: right;"
    };
  },
  lowercase: function lowercase() {
    return {
      styles: "text-transform: lowercase;"
    };
  },
  uppercase: function uppercase() {
    return {
      styles: "text-transform: uppercase;"
    };
  },
  disclaimer: function disclaimer() {
    return {
      styles: "\n      border: 1px solid rgba(61, 113, 78, 0.145);\n      background-color: rgba(61, 113, 78, 0.082);\n      padding: 0.5rem 1rem;\n      width: fit-content;\n      margin: 1rem auto 0px;\n    "
    };
  }
};
exports.TextStyled = styled_components_1.default.p.attrs({
  className: 'Text'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 0.875rem;\n  line-height: 1.6rem;\n  letter-spacing: 0.05rem;\n  color: ", ";\n  padding: 0;\n  margin: 0;\n  * {\n    font-size: inherit;\n  }\n  a {\n    text-decoration: underline;\n  }\n\n  ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.farmProject.font_family_text;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.farmProject.dark_gray;
}, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));